import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

const lineVariants = {
  hidden: { y: "110%" },
  show: (d) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: d } }),
};

export const MaskLines = ({ lines, className = "", delay = 0, inView = false }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(inView ? { whileInView: "show", viewport: { once: true, amount: 0 } } : { animate: "show" })}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
        <motion.span className="block will-change-transform" variants={lineVariants} custom={delay + i * 0.12}>
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const Overline = ({ children, color = "bg-coral" }) => (
  <p className="mb-6 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-ink/70">
    <span className={`h-2 w-2 rounded-full ${color}`} />
    {children}
  </p>
);
